import * as React from "react";
import { px2rem } from "common/helpers/rem";
import { LoadMoreThreads } from "../styledComponents";
import { FormattedMessage } from "react-intl";
import PulseLoadingDot from "../pulseLoadingDot";

function ThreadLoadMore({
  isLoading,
  pagingKey,
  contentType,
  onLoadMoreData,
}: {
  isLoading: boolean;
  pagingKey: keyof Vingle.IPaging;
  contentType: string;
  onLoadMoreData: (pagingDirection: keyof Vingle.IPaging) => void;
}) {
  const handleLoadMore = React.useCallback(() => {
    onLoadMoreData(pagingKey);
  }, [pagingKey, onLoadMoreData]);
  return isLoading ? (
    <div style={{ height: px2rem(70) }}>
      <PulseLoadingDot />
    </div>
  ) : (
    <LoadMoreThreads onClick={handleLoadMore}>
      <FormattedMessage
        id={`view_${pagingKey === "after" ? "more" : "previous"}_thread`}
        values={{ contentType }}
      />
    </LoadMoreThreads>
  );
}

export default function getLoadMoreButtonSet({
  paging,
  hasData,
  isLoading,
  name,
  onLoadMoreData,
}: {
  paging: Vingle.IPaging;
  hasData: boolean;
  isLoading: boolean;
  name: string;
  onLoadMoreData: (pagingDirection: keyof Vingle.IPaging) => void;
}): { [key in keyof Vingle.IPaging]: React.ReactNode } {
  const hasMore = Boolean(paging.after || paging.before);
  let loadMoreButton = {};

  if (hasMore && hasData) {
    loadMoreButton = Object.entries(paging).reduce<
      {
        [key in keyof Writeable<Vingle.IPaging>]: React.ReactNode;
      }
    >(
      (result, [key, value]: [keyof Vingle.IPaging, Vingle.PagingValue]) => {
        if (value) {
          result[key] = (
            <ThreadLoadMore
              pagingKey={key}
              isLoading={Boolean(isLoading)}
              contentType={name}
              onLoadMoreData={onLoadMoreData}
            />
          );
        }
        return result;
      },
      {
        before: null,
        after: null,
      },
    );
  }

  return loadMoreButton;
}
